import ApiGenericServicesData from "service/ApiGenericServicesData";
import { codificarValorSeguro } from "util/codificarValorSeguro";

export default class ConstanciaCandidatoEleccionPopular extends ApiGenericServicesData {
  constructor() {
    super("constanciaCandidatoEleccionPopular");
  }

  async openFile(fileName) {
    const fileNameSeguro = await codificarValorSeguro(fileName);
    return this.customGET("openFile/" + fileNameSeguro);
  }
}
